module.exports = __webpack_public_path__ + "img/product_128.741c69f.webp";